import { type State } from './state.js';

export const getEnabledPayouts = (
  state: State,
): State['payoutTypesEnabled'] => {
  const eligibility = state.payoutAccountEligibility;

  return {
    PAYOUT_Airwallex_Local_Bank:
      eligibility.airwallexPayouts.eligibilityStatus === 'ELIGIBLE' &&
      (eligibility.airwallexPayouts.airwallexBankAccountSupport ===
        'LOCAL_BANK_VIA_LOCAL_RAIL' ||
        eligibility.airwallexPayouts.airwallexBankAccountSupport ===
          'LOCAL_BANK_VIA_SWIFT_ONLY'),

    PAYOUT_Airwallex_US_Bank_Only:
      eligibility.airwallexPayouts.eligibilityStatus === 'ELIGIBLE',

    PAYOUT_Crypto: eligibility.usdcPayouts.eligibilityStatus === 'ELIGIBLE',

    PAYOUT_Payoneer:
      eligibility.payoneerPayouts.eligibilityStatus === 'ELIGIBLE',

    PAYOUT_Paypal: eligibility.paypalPayouts.eligibilityStatus === 'ELIGIBLE',

    PAYOUT_Stripe_Local_Bank:
      eligibility.stripeBankAccountPayouts.eligibilityStatus === 'ELIGIBLE',

    PAYOUT_Stripe_Local_Debit_Card:
      eligibility.stripeDebitCardPayouts.eligibilityStatus === 'ELIGIBLE',
  };
};

export const isCountrySanctioned = (state: State): boolean => {
  return (
    state.payoutAccountEligibility.stripeBankAccountPayouts
      .eligibilityStatus === 'INELIGIBLE_COUNTRY_SANCTIONED' &&
    state.payoutAccountEligibility.stripeDebitCardPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_SANCTIONED' &&
    state.payoutAccountEligibility.usdcPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_SANCTIONED'
  );
};

export const isCountrySupported = (state: State): boolean => {
  return !(
    state.payoutAccountEligibility.stripeBankAccountPayouts
      .eligibilityStatus === 'INELIGIBLE_COUNTRY_NOT_SUPPORTED' &&
    state.payoutAccountEligibility.stripeDebitCardPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_NOT_SUPPORTED' &&
    state.payoutAccountEligibility.usdcPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_NOT_SUPPORTED' &&
    state.payoutAccountEligibility.paypalPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_NOT_SUPPORTED' &&
    state.payoutAccountEligibility.payoneerPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_NOT_SUPPORTED' &&
    state.payoutAccountEligibility.airwallexPayouts.eligibilityStatus ===
      'INELIGIBLE_COUNTRY_NOT_SUPPORTED'
  );
};
